import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'hooks';
import Form from 'components/ui/form';
import Button from 'components/ui/button';
import InputPassword from 'components/ui/inputPassword';
import Icon from 'components/ui/icon';

interface Props {
  password: string;
  passwordType: string;
  passwordConfirm: string;
  passwordConfirmType: string;
  settings: any;
  validation: any;
  onChange: (key: string, value: any) => void;
  onSave: () => void;
}

const PasswordChangeFormLegacy: React.FC<Props> = ({
  password,
  passwordType,
  passwordConfirm,
  passwordConfirmType,
  settings,
  validation,
  onChange,
  onSave,
}) => {
  const getTranslate = useTranslation();
  const passwordInput = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const field = passwordInput.current?.querySelector(
      '.ui-input__field'
    ) as HTMLDivElement;

    field.focus();
  }, []);

  const savePassword = () => {
    if (canChange()) {
      onSave();
    }
  };

  const canChange = () => {
    return Boolean(password && passwordConfirm) && password === passwordConfirm;
  };

  return (
    <div className='auth-form'>
      <Form onSubmit={savePassword}>
        <div className='auth-form__fields'>
          <div className='auth-form__row' ref={passwordInput}>
            <InputPassword
              customClass={classNames({ 'ui-input_empty': !password })}
              id='password'
              type={passwordType}
              label={getTranslate('auth.changePassword.newPassword.label')}
              placeholder={getTranslate('auth.newPasswordPlaceholder')}
              value={password}
              onChange={(event) => onChange('password', event.target.value)}
              error={validation && validation.newPassword}
              modern
              suffix={
                <Icon
                  onClick={() =>
                    onChange(
                      'passwordType',
                      passwordType === 'password' ? 'text' : 'password'
                    )
                  }
                  name={
                    passwordType === 'password' ? 'im-Eye-close' : 'im-Eye-open'
                  }
                />
              }
            />
          </div>

          <div className='auth-form__row'>
            <InputPassword
              customClass={classNames({ 'ui-input_empty': !passwordConfirm })}
              id='passwordConfirm'
              type={passwordConfirmType}
              label={getTranslate('auth.changePassword.confirmPassword.label')}
              placeholder={getTranslate('auth.passwordConfirmPlaceholder')}
              value={passwordConfirm}
              error={validation && validation.newPassword2}
              onChange={(event) =>
                onChange('passwordConfirm', event.target.value)
              }
              modern
              suffix={
                <Icon
                  onClick={() =>
                    onChange(
                      'passwordConfirmType',
                      passwordConfirmType === 'password' ? 'text' : 'password'
                    )
                  }
                  name={
                    passwordConfirmType === 'password'
                      ? 'im-Eye-close'
                      : 'im-Eye-open'
                  }
                />
              }
            />
          </div>
        </div>

        <Button
          text={getTranslate('auth.changePassword.confirm.button')}
          status='primary'
          type='submit'
          disabled={!canChange()}
          size='large'
          customClass='page-auth__btn ui-button_full-width'
        />
        <div className='page-auth__link'>
          <a href={`mailto:${settings.supportEmail}`} className='utils-link'>
            {getTranslate('auth.contact.link')}
          </a>
        </div>
      </Form>
    </div>
  );
};

export { PasswordChangeFormLegacy };
